import {Component,StrictMode,type ErrorInfo,type ReactNode} from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './App';
import {StageZeroGate} from './StageZero';
import {installSmmRuntimePort} from './runtime';
import {createPwaRuntimePort} from './pwa-runtime';
import './styles.css';
import './ui-kit.css';
import '../../../contracts/morefun-brand-r31.css';
import './mobile-brand-r31.css';

class SmmErrorBoundary extends Component<{children:ReactNode},{failed:boolean}>{
  state={failed:false};
  static getDerivedStateFromError(){return{failed:true};}
  componentDidCatch(error:Error,info:ErrorInfo){
    console.error('SMM_RENDER_RECOVERED',error,info.componentStack);
  }
  render(){
    if(!this.state.failed)return this.props.children;
    return <main className="app-shell"><section className="panel"><h2>未能顯示，請重新載入</h2><button className="primary" onClick={()=>location.reload()}>重新載入</button></section></main>;
  }
}

installSmmRuntimePort(createPwaRuntimePort());

const root=document.getElementById('root');
if(!root)throw new Error('MFK_SMM_ROOT_REQUIRED');
createRoot(root).render(<StrictMode><SmmErrorBoundary><StageZeroGate><App/></StageZeroGate></SmmErrorBoundary></StrictMode>);


if('serviceWorker'in navigator){
  window.addEventListener('load',()=>{void navigator.serviceWorker.register('/sw.js',{scope:'/'}).then(registration=>registration.update()).catch(()=>{});});
}
